import { useMemo } from 'react';
import { getPrefixedSkillLabel } from '../utils/categories';
import { useSkillCategories } from './useSkillCategories';
const createSkillLookup = categories => {
  const lookup = {};
  for (const category of categories) {
    for (const skill of category.options) {
      lookup[`${category.name}:${skill.value}`] = {
        skill,
        category
      };
    }
  }
  return lookup;
};
const formatSkillLabels = (categories, skills) => {
  const lookup = createSkillLookup(categories);
  const skillLabels = [];
  for (const skill of skills) {
    const skillOption = lookup[skill];
    if (skillOption) {
      skillLabels.push(getPrefixedSkillLabel(skillOption.category, skillOption.skill.label));
    }
  }
  return skillLabels;
};
export const useSkillLabels = skills => {
  const {
    categories,
    loading
  } = useSkillCategories();
  const labels = useMemo(() => {
    if (categories) {
      return formatSkillLabels(categories, skills);
    }
    return [];
  }, [categories, skills]);
  return {
    labels,
    loading
  };
};